import { Component, OnInit, AfterViewInit } from '@angular/core';
import { FormEntryComponentClass, FormComponentLookup } from '@ptl/forms';
import { DateService } from 'src/app/shared/services/date.service';
import { environment } from 'src/environments/environment';

@FormComponentLookup('coverage-dropdown-select')
@Component({
    selector: 'app-coverage-dropdown-select',
    templateUrl: './coverage-dropdown-select.component.html',
    styleUrls: ['./coverage-dropdown-select.component.scss'],
    standalone: false
})
export class CoverageDropdownSelectComponent extends FormEntryComponentClass implements OnInit, AfterViewInit {
  constructor(
    private dateUtility: DateService
  ) {
    super();
  }

  ngOnInit() {
    const selectMonth = this.dateUtility.getTodayAsMoment();
    const monthsToShow = this.entry.custom?.monthsToShow || 3;

    for (let i = 0; i < monthsToShow; i++) {
      selectMonth.add(1, 'M').startOf('month');

      this.entry.selectAttributes.optionAttributes.push({
        label: selectMonth.format('LL'), //`${monthValues[currentMonth]}/${date}/${currentYear}`,
        value: selectMonth.toISOString()  //`${monthValues[currentMonth]}/${date}/${currentYear}`
      });
    }
  }

  /** Clear dropdown */
  ngOnDestroy() {
    this.entry.selectAttributes.optionAttributes = [];
  }
}

